import {
    ActionFunction,
    redirect
} from "react-router-dom";
import { axiosApi } from "../../../interceptors/axios";
import { toast } from "react-toastify";


export const uploadPreferencesAction: ActionFunction = async ({ request, params }) => {
    const formData = await request.formData();
    formData.append("assignmentPeriodCode", params.assignmentPeriodCode!);
    await toast.promise(axiosApi.postForm("/api/preferences/upload", formData), { pending: "Dosya işleniyor...", success: "Dosya aktarımı başarılı", error: "Dosya aktarımında hata oluştu" });
    return redirect(`/assignment-periods/${params.assignmentPeriodCode}/preferences`);
}